@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: spacing("24");
}

.pageTitle {
  @include typography("Jp/24_W6");
  color: text("High");
  margin-bottom: spacing("24");
}

.content {
  margin-top: spacing("24");
}

.assessmentTab {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
}
